import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input } from '@angular/core';

import { PassengersSeats, SeatMap, WingTypes } from '@seat-map/entities/seat-map';

@Component({
  selector: 'app-seats-map-wings',
  templateUrl: './seats-map-wings.component.html',
  styleUrls: ['./seats-map-wings.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SeatsMapWingsComponent {

  @Input() seatMapSeat: PassengersSeats[];
  @Input() seatMap: SeatMap;
  @Input() orientationRight: boolean;
  @Input() isLarge: boolean;

  constructor() {
    this.orientationRight = false;
    this.isLarge = false;
  }

  get wingTypes(): typeof WingTypes {
    return WingTypes;
  }
}
